// const API_URL = `https://api.imisepela.com/v1/admin`;
// const API_URL = `https://seed.api.imisepela.com/v1/admin`;
const API_URL = `${process.env.REACT_APP_API_URL}/v1/admin`;

exports.SIGNIN_URL = `${API_URL}/core-sign-in`;
exports.UAC_URL = `${API_URL}/uac`;
exports.EMPLOYER_URL = `${API_URL}/employer`;
exports.GET_COLLECTION_DATA = `${API_URL}/collection-data`;
exports.GET_COLLECTION_AGGREGATE_DATA = `${API_URL}/collection-aggregate-data`;
exports.SEARCH_COLLECTION_URL = `${API_URL}/search-collection`;
exports.MEDIA_URL = `${API_URL}/media`;
exports.OPPORTUNITY_URL = `${API_URL}/opportunity`;
exports.PAYOUT_URL = `${API_URL}/payout`;
exports.TOPUP_WALLET_URL = `${API_URL}/top-up-wallet`;
exports.JOB_URL = `${API_URL}/job`;
exports.GET_FINANCE_REPORT_URL = `${API_URL}/finance-report`;
exports.APPLICATION_URL = `${API_URL}/application`;
exports.GRANT_URL = `${API_URL}/grant`;
exports.GET_APPLICANT_REPORT_URL = `${API_URL}/applicant-report`;
exports.GET_LOAN_REPORT_URL = `${API_URL}/loan-report`;
exports.GET_GRANT_REPORT_URL = `${API_URL}/grant-report`;
exports.GET_PRE_SIGNED_URL = `${API_URL}/generate-pre-signed-url`;
exports.GET_MEMBERSHIP_REPORT_URL = `${API_URL}/membership-report`;
exports.GET_LOAN_APPLICATION_REPORT_URL = `${API_URL}/loan-application-report`;
exports.GET_INVESTMENT_REPORT_URL = `${API_URL}/investment-report`;
exports.COMPANY_URL = `${API_URL}/company`;
exports.SYNC_URL = `${API_URL}/sync`;
exports.USER_URL = `${API_URL}/user`;
exports.DEPOSIT_URL = `${API_URL}/deposit`;
exports.INVESTMENT_URL = `${API_URL}/investment`;
exports.NOTICEBOARD_URL = `${API_URL}/noticeboard`;
exports.GET_LIVE_ACCOUNT_URL = `${API_URL}/account-balance`;
exports.GET_USER_URL = (id) => `${API_URL}/user/${id}`;
exports. GET_COL_AGGREGATE_DATA = `${API_URL}/col-aggregate-data`;
